import { render, staticRenderFns } from "./ChangePolicyFormError.vue?vue&type=template&id=6507fb3c&scoped=true"
import script from "./ChangePolicyFormError.vue?vue&type=script&lang=js"
export * from "./ChangePolicyFormError.vue?vue&type=script&lang=js"
import style0 from "./ChangePolicyFormError.vue?vue&type=style&index=0&id=6507fb3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6507fb3c",
  null
  
)

export default component.exports